var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16071 1C6.713 1 7.16071 1.44772 7.16071 2V2.6875H16.625V2C16.625 1.44772 17.0727 1 17.625 1C18.1773 1 18.625 1.44772 18.625 2V2.80231C20.5594 3.2546 22 4.99031 22 7.0625L22 18.3126C22 20.7288 20.0412 22.6876 17.625 22.6876H6.375C3.95875 22.6876 2 20.7288 2 18.3126V7.0625C2 5.06758 3.33521 3.38451 5.16071 2.85821V2C5.16071 1.44772 5.60843 1 6.16071 1ZM6.375 4.6875C5.06332 4.6875 4 5.75082 4 7.0625V7.47649C4.04095 7.47138 4.08267 7.46875 4.125 7.46875H19.875C19.9173 7.46875 19.9591 7.47138 20 7.47649V7.0625C20 5.75082 18.9367 4.6875 17.625 4.6875H6.375ZM20 9.46101C19.9591 9.46612 19.9173 9.46875 19.875 9.46875H4.125C4.08267 9.46875 4.04095 9.46612 4 9.46101V18.3126C4 19.6243 5.06332 20.6876 6.375 20.6876H17.625C18.9367 20.6876 20 19.6243 20 18.3126L20 9.46101ZM15.5196 12.2617C15.9101 12.6522 15.9101 13.2854 15.5196 13.6759L11.5821 17.6134C11.1916 18.0039 10.5584 18.0039 10.1679 17.6134L8.48039 15.9259C8.08987 15.5354 8.08987 14.9022 8.48039 14.5117C8.87092 14.1212 9.50408 14.1212 9.89461 14.5117L10.875 15.4921L14.1054 12.2617C14.4959 11.8712 15.1291 11.8712 15.5196 12.2617Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheck);
export default __webpack_public_path__ + "static/media/calendarCheck.f42172db863c773325fa615ca00285ca.svg";
export { ForwardRef as ReactComponent };